import { formatPrice } from "shared";

export const formatGain = (gain: number | null) =>
  formatPrice(gain === null ? 0 : -gain, " €", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
